<!--unitOverview 单位概况-->
<template>
  <div class="unitOverview">
    <!-- 第一行 -->
    <div class="one">
      <left style="flex: 2;"></left>
      <!-- 地图 -->
      <div class="right left" style="flex: 1;">
        <div class="t" style="margin-bottom: 0;padding-bottom: 0;">
          <div class="tit">站点地图分布</div>
          <div class="map">
            <webMap
              style="width: 100%;height: 100%;min-height: 200px;"
              :flag="true"
            ></webMap>
          </div>
        </div>
      </div>
    </div>
    <!-- 第2行 -->
    <two></two>
    <!-- 第3行 -->
    <!-- <three></three> -->

    <div class="four" style="margin-bottom: 40px;">
      <div class="left">
        <div class="tit" style="position: absolute;">电量电费统计</div>
        <div class="t" style="margin-top: 12px;">
          <vchart class="vchart" ref="vchart"></vchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vchart from "../../components/module/Charts/chart.vue"; //echart图
import webMap from "@/page/webMap/webMap.vue";
import left from "./left.vue";
import two from "./two.vue";
import three from "./three.vue";
export default {
  components: {
    webMap,
    left,
    two,
    three,
    vchart,
  },
  data() {
    return {
      barOption2: {
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
              "30",
              "31",
            ],
            axisLabel: {
              textStyle: {
                color: "#000",
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#6f7284",
              },
            },
          },
        ],
        yAxis: [
          {
            max: 1000,
            title: "能耗值（KWH）",
            type: "value",
            axisLabel: {
              textStyle: {
                color: "#3D3D3D",
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#E5E5E5",
              },
            },
          },
        ],
        legend: {
          right: 30,
          top: 5,
          padding: [0, 0, 0, 50],
          bottom: "5px",
        },
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            animation: false,
          },
        },
        grid: {
          left: "1%",
          right: "40",
          bottom: "1%",
          top: "25%",
          containLabel: true,
        },
        series: [
          {
            name: "电量",
            type: "bar",
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#005EFF",
                    },
                    {
                      offset: 1,
                      color: "#005EFF",
                    },
                  ],
                },
              },
            },
            data: [
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
              700,
            ],
          },
          {
            name: "电费",
            type: "bar",
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#FF9532",
                    },
                    {
                      offset: 1,
                      color: "#FF9532",
                    },
                  ],
                },
              },
            },
            data: [
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
              500,
            ],
          },
        ],
      },

      nowScale: 50, //当前缩放倍率
      token: "", //token
      ids: [],
      svgPath: "",
    };
  },

  mounted() {
    this.$refs.vchart.setData(this.barOption2, true);
  },
  destroyed() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.four {
  display: flex;
  margin-top: 12px;
  position: relative;

  .box {
    display: flex;
  }

  .left {
    background-color: #fff;
    border-radius: 4px;
    padding-left: 12px;
    width: 100%;
  }
}

.one {
  display: flex;

  .right {
    background-color: #fff;
    flex: 1;
    margin-left: 12px;
    border-radius: 4px;

    .map {
      position: relative;
      margin-right: 12px;
    }
  }
}

.unitOverview {
  background-color: #edf0f4;
  padding: 20px;
}

.left {
  .t {
    background-color: #fff;
    padding-left: 12px;
    margin-bottom: 12px;
    overflow: hidden;
    border-radius: 4px;
  }
}

.tit {
  height: 18px;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: bold;
  color: #1a1a1a;
  margin-top: 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-right: 20px;

  .line {
    width: 52px;
    height: 17px;
    font-family: Microsoft YaHei;
    font-size: 13px;
    font-weight: normal;
    color: #666;
    cursor: pointer;
  }
}

.vchart {
  width: 100%;
  height: 240px;
}
</style>
